export default __webpack_public_path__ + "static/media/ig-logo.48984e6d.png";